/**
 * Modal - H5 版本
 * 使用 zarm Modal
 */
import type { ShowModalOptions } from './types';
import classNames from 'classnames';
import React from 'react';
import { Modal as ZarmModal } from 'zarm-v3';

import './index.scss';

const IconCloseUrl = 'https://static.za-doctor.com/za-asclepius-applet/common/w_icon_close.png';

export type { ShowModalOptions } from './types';

export interface IsomorphicModalProps {
  visible: boolean;
  onClose: () => void;
  /** 弹窗完全关闭后的回调（动画结束后触发） */
  onAfterClose?: () => void;
  className?: string;
  children?: React.ReactNode;
  /** H5 专用：挂载容器，小程序下忽略 */
  mountContainer?: HTMLElement | null;
  /** 是否在弹窗底部显示关闭图标 */
  showClose?: boolean;
  /** 点击遮罩是否可关闭弹窗 (默认 false) */
  maskClosable?: boolean;
}

export const Modal: React.FC<IsomorphicModalProps> = ({
  visible,
  onClose,
  onAfterClose,
  className,
  children,
  mountContainer,
  showClose,
  maskClosable = false,
}) => (
  <ZarmModal
    visible={visible}
    onMaskClick={maskClosable ? onClose : undefined}
    afterClose={onAfterClose}
    {...(mountContainer ? { mountContainer } : {})}
    className={classNames('hy-modal', className)}
  >
    {children}
    {showClose && (
      <div className='hy-modal__close-bottom'>
        <img src={IconCloseUrl} alt='close' onClick={onClose} />
      </div>
    )}
  </ZarmModal>
);

type ZarmAlertOptions = Parameters<typeof ZarmModal.alert>[0];
type ZarmConfirmOptions = Parameters<typeof ZarmModal.confirm>[0];

export function showModal(options: ShowModalOptions): Promise<void> {
  return new Promise((resolve) => {
    const alertOptions: ZarmAlertOptions & { cancelText?: string; onCancel?: () => void } = {
      title: <b>{options.title ?? '温馨提示'}</b>,
      content: <p style={{ fontSize: '13px', lineHeight: '20px' }}>{options.content}</p>,
      confirmText: options.cancelText ?? '我知道了',
      cancelText: options.cancelText ?? '取消',
      onConfirm: () => {
        options.onConfirm?.();
        resolve();
      },
      onCancel: () => {
        options.onCancel?.();
        resolve();
      },
    };
    if (options.showCancel) {
      ZarmModal.confirm(alertOptions as ZarmConfirmOptions);
    } else {
      ZarmModal.alert(alertOptions as ZarmAlertOptions);
    }
  });
}

export default Modal;
